// Initialize GLightbox for all elements with data-glightbox attribute
// Caption is read from data-description or the surrounding figure > figcaption
import GLightbox from 'glightbox';

export function initGLightbox() {
    const triggers = document.querySelectorAll('.glightbox');
    if (!triggers.length) return null;

    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: false,
        autoplayVideos: false,
        descPosition: 'right',
        cssEfects: {
            fade: { in: 'fadeIn', out: 'fadeOut' }
        },
        keyboardNavigation: true,
        closeButton: true,
        moreText: 'mehr lesen',
        moreLength: 100,
        svg: {
            close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',
            next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>',
            prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>'
        }
    });

    return lightbox;
}
